"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _flowbiteReact = require("flowbite-react");
var _goLogo = _interopRequireDefault(require("../icons/go-logo.svg"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const SiteFooter = _ref => {
  let {
    logo,
    ftrInfo,
    ftrInfo2,
    textBottom
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_flowbiteReact.Footer, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "w-full mx-auto max-w-screen-xl px-4 sm:px-6 lg:px-16",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "w-full py-6 px-4 sm:flex sm:items-center sm:justify-between text-primaryLight footer-content",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_flowbiteReact.Footer, {
          bgDark: true,
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "w-full container",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              className: "w-full py-6 px-2 sm:flex sm:items-center sm:justify-between",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                className: "flex justify-start",
                children: logo !== undefined && logo !== "" ? logo : /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                  alt: "logo",
                  src: _goLogo.default,
                  className: "w-[194.11px] h-[23.38px]"
                })
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
              className: ftrInfo.length > 0 ? "w-full py-8 px-4 sm:px-6" : "",
              children: [ftrInfo.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                className: "grid grid-cols-1 gap-12 md:grid-cols-3 mb-10",
                children: [ftrInfo.map((info, index) => {
                  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
                      className: "mb-6 text-sm font-semibold uppercase ",
                      children: info.title
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
                      className: "text-white dark:text-gray-400 font-bold",
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                        className: "grid grid-rows-2 grid-flow-col gap-2",
                        children: info.subContent ? info.subContent.map((sub, i) => {
                          return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                            children: [sub.content, /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
                              className: "mb-4",
                              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
                                href: sub.link,
                                className: "hover:underline font-light",
                                children: sub.info
                              })
                            })]
                          }, i);
                        }) : ""
                      })
                    })]
                  }, index);
                }), ftrInfo2.map((info, index) => {
                  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
                      className: "mb-6 text-sm font-semibold uppercase",
                      children: info.title
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
                      className: "text-white dark:text-gray-400 font-light",
                      children: info.content.map((i, index) => {
                        return /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
                          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
                            href: i.link,
                            className: "hover:underline block",
                            children: i.title
                          })
                        }, index);
                      })
                    })]
                  }, index);
                })]
              }), textBottom.props.children != null && textBottom.props.children !== "" && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("hr", {
                  className: "divider"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  className: "font-light",
                  children: textBottom
                })]
              })]
            })]
          })
        })
      })
    })
  });
};
var _default = SiteFooter;
exports.default = _default;